module.exports = __webpack_public_path__ + "static/media/national-2-web-bold.834a8070.woff";